import React from "react";
import TwitterIcon from "../../../images/bitcoin-live/TwitterIcon.png";
import introVideoIcon from "../../../images/bitcoin-live/Intro_Vid_Icon.png";
import "./AnalystCarouselCard.scss";

/** "Peter brandt" → "Peter brandt's", "Big Cheds" → "Big Cheds'" */
const introPossessive = (name) => {
  const trimmed = (name || "").trim();
  if (!trimmed) return "";
  return /s$/i.test(trimmed) ? `${trimmed}'` : `${trimmed}'s`;
};

const AnalystCarouselCard = ({ analyst, onIntroClick, className = "" }) => {
  const hasIntro = Boolean(analyst.introVideo);
  const introLabel = `Watch ${introPossessive(analyst.name)} intro`;

  return (
    <div className={`analyst-carousel-item ${className}`.trim()}>
      <article className="analyst-carousel-card">
        <div className="analyst-carousel-card__avatar-wrap">
          <img
            className="analyst-carousel-card__avatar"
            src={analyst.profilePic}
            alt={`${analyst.name} profile`}
          />
        </div>

        <div className="analyst-carousel-card__panel">
          <div className="analyst-carousel-card__body">
            <div className="analyst-carousel-card__name">
              <span className="analyst-carousel-card__name-text">{analyst.name}</span>
              {analyst.twitterUrl && (
                <a
                  className="analyst-carousel-card__name-twitter"
                  href={analyst.twitterUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow ${analyst.name} on X`}
                >
                  <img src={TwitterIcon} alt="" />
                </a>
              )}
            </div>

            <ul className="analyst-carousel-card__list">
              {analyst.content.map((item, index) => (
                <li key={`${analyst.name}-${index}`} className="analyst-carousel-card__list-item">
                  <span className="analyst-carousel-card__list-bullet" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <div className="analyst-carousel-card__footer">
              {hasIntro ? (
                <button
                  type="button"
                  className="analyst-carousel-card__cta analyst-carousel-card__cta--primary"
                  title={introLabel}
                  aria-label={introLabel}
                  onClick={() => onIntroClick(analyst.introVideo)}
                >
                  <span>Watch intro</span>
                  <img src={introVideoIcon} alt="" />
                </button>
              ) : analyst.twitterUrl ? (
                <a
                  className="analyst-carousel-card__cta analyst-carousel-card__cta--ghost"
                  href={analyst.twitterUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Follow on X
                </a>
              ) : (
                <span
                  className="analyst-carousel-card__cta analyst-carousel-card__cta--placeholder"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
        </div>
      </article>
    </div>
  );
};

export default AnalystCarouselCard;
